import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { Datenschutz, Impressum } from "./pages/LegalPages";
import { Toaster } from "./components/ui/sonner";
import CookieConsent from "./components/CookieConsent";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
